import React from 'react';
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaYoutube,
  FaArrowUp,
  FaBuilding,
  FaCog,
  FaHammer
} from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { useTheme } from '../../contexts/ThemeContext';

import Logo from '../../assets/round.jpg';
import '../Footer/Footer.css';

function Footer() {
  const location = useLocation();
  const { theme } = useTheme();
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className='modern-footer'>
      <div className='container'>
        <div className='footer-content'>
          <div className='footer-section footer-brand'>
            <div className='brand-info'>
              <img
                src={Logo}
                alt='Amruth Build Products Logo'
                className='footer-logo'
                loading='lazy'
              />
              <h3 className='brand-title'>
                Amruth Build Products
              </h3>
              <p className='brand-description'>
                Architects of progress, builders of dreams, and champions of innovation. 
                We redefine industry standards and pave the way for a brighter tomorrow.
              </p>
            </div>
            <div className='social-section'>
              <h4 className='social-title'>Follow Us</h4>
              <div className='social-links'>
                <Link
                  to='https://www.facebook.com/profile.php?id=100086127334544'
                  title='Facebook'
                  target='_blank'
                  className='social-link'
                >
                  <FaFacebook />
                </Link>
                <Link
                  to='https://www.instagram.com/amruth_build_product/'
                  target='_blank'
                  title='Instagram'
                  className='social-link'
                >
                  <FaInstagram />
                </Link>
                <Link
                  to='https://www.linkedin.com/company/amruth-organic-fertilizers/'
                  title='LinkedIn'
                  target='_blank'
                  className='social-link'
                >
                  <FaLinkedin />
                </Link>
                <Link
                  to='https://www.youtube.com/@AMRUTHORGANICFERTILIZERS/featured'
                  title='YouTube'
                  target='_blank'
                  className='social-link'
                >
                  <FaYoutube />
                </Link>
              </div>
            </div>
          </div>
          <div className='footer-section'>
            <h4 className='section-title-footer'>Quick Links</h4>
            <ul className='footer-links'>
              <li>
                <Link
                  className={location.pathname === '/' ? 'footer-link active' : 'footer-link'}
                  to='/'
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  className={location.pathname === '/about' ? 'footer-link active' : 'footer-link'}
                  to='/about'
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  className={location.pathname === '/products' ? 'footer-link active' : 'footer-link'}
                  to='/products'
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  className={location.pathname === '/projects' ? 'footer-link active' : 'footer-link'}
                  to='/projects'
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  className={location.pathname === '/services' ? 'footer-link active' : 'footer-link'}
                  to='/services'
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  className={location.pathname === '/contact' ? 'footer-link active' : 'footer-link'}
                  to='/contact'
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className='footer-section'>
            <h4 className='section-title-footer'>
              Services
            </h4>
            <ul className='footer-links'>
              <li><span className='footer-text'>Planning & Designing</span></li>
              <li><span className='footer-text'>Estimation & Costing</span></li>
              <li><span className='footer-text'>Turnkey Projects</span></li>
              <li><span className='footer-text'>Project Management</span></li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4 className='section-title-footer'>
              Products  
            </h4>
            <div className='product-categories'>
              <div className='product-category'>
                <h5 className='category-title'>Manufacturing</h5>
                <ul className='footer-links'>
                  <li><span className='footer-text'>Solid Blocks</span></li>
                  <li><span className='footer-text'>Paver Blocks</span></li>
                  <li><span className='footer-text'>Kerb Stones</span></li>
                  <li><span className='footer-text'>Precast Walls</span></li>
                </ul>
              </div>
              <div className='product-category'>
                <h5 className='category-title'>Construction</h5>
                <ul className='footer-links'>
                  <li><span className='footer-text'>Cement</span></li>
                  <li><span className='footer-text'>TMT Steel</span></li>
                  <li><span className='footer-text'>Sand & Aggregates</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className='footer-bottom'>
          <div className='footer-bottom-content'>
            <p className='copyright'>
              &copy; {new Date().getFullYear()} Amruth Build Products. All rights reserved | Developed by{' '}
              <a 
                href='https://wa.me/916362091042'
                target='_blank' 
                rel='noopener noreferrer'
                className='developer-link'
                title='Contact Developer on WhatsApp'
              >
                Prabhudda
              </a>
            </p>
            <button
              className='scroll-to-top'
              onClick={scrollToTop}
              title='Scroll to top'
              aria-label='Scroll to top'
            >
              <FaArrowUp size={10}/>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
